document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nexly-slideshow').forEach((el) => {
    initSlideshow(el);
  });
});

function initSlideshow(root) {
  const slides = Array.from(root.querySelectorAll('.nexly-slide'));
  const dots = Array.from(root.querySelectorAll('.nexly-dot'));
  const prevBtn = root.querySelector('.nexly-slideshow__arrow--prev');
  const nextBtn = root.querySelector('.nexly-slideshow__arrow--next');
  const viewport = root.querySelector('.nexly-slideshow__viewport');

  if (slides.length === 0) return;

  let currentIndex = 0;
  let timer = null;
  let touchStartX = 0;
  let touchEndX = 0;

  const autoplay = root.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
  const pauseOnHover = root.dataset.pauseHover === 'true';

  function goToSlide(index) {
    const total = slides.length;
    if (total === 0) return;

    const nextIndex = (index + total) % total;

    slides[currentIndex].classList.remove('is-active');
    slides[currentIndex].classList.add('is-prev');

    slides[nextIndex].classList.add('is-active');
    slides[nextIndex].classList.remove('is-prev');

    if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');
    if (dots[nextIndex]) dots[nextIndex].classList.add('is-active');

    slides.forEach((slide, i) => {
      if (i !== nextIndex && i !== currentIndex) {
        slide.classList.remove('is-prev');
      }
    });

    currentIndex = nextIndex;
  }

  function startAutoplay() {
    if (slides.length <= 1) return;
    stopAutoplay();
    timer = setInterval(() => {
      goToSlide(currentIndex + 1);
    }, autoplaySpeed);
  }

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function restartAutoplay() {
    if (autoplay) startAutoplay();
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      goToSlide(currentIndex - 1);
      restartAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      goToSlide(currentIndex + 1);
      restartAutoplay();
    });
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.dotIndex, 10);
      goToSlide(index);
      restartAutoplay();
    });
  });

  if (pauseOnHover) {
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', () => {
      if (autoplay) startAutoplay();
    });
  }

  if (viewport) {
    viewport.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    viewport.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const threshold = 40;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) < threshold) return;
      if (diff > 0) {
        goToSlide(currentIndex + 1);
      } else {
        goToSlide(currentIndex - 1);
      }
      restartAutoplay();
    }, { passive: true });
  }

  root.setAttribute('tabindex', '0');
  root.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      goToSlide(currentIndex - 1);
      restartAutoplay();
    } else if (e.key === 'ArrowRight') {
      goToSlide(currentIndex + 1);
      restartAutoplay();
    }
  });

  if (slides.length <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
  }

  if (autoplay && slides.length > 1) {
    startAutoplay();
  }
}
